export default __webpack_public_path__ + "static/media/featured-item-4.e3c10d88.png";